export default __webpack_public_path__ + "static/media/image 72.0153ab61.webp";